<template>
  <div
    v-bind:style="showModalAppointments ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Asignación de citas :: {{serviceSelected === 'IMPO' ? 'Descarga' : 'Embarque'}} - {{port.name}}</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <b-form>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>Cantidad de citas por hora</label>
                <input type="text" v-model="qty" class="form-control"/>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>Tipo de Carga</label>
                <select v-model="charge_type_id" class="form-control">
                  <option :value="null">Seleccione tipo de carga</option>
                  <option v-for="(charge_type, index) in specialChargeTypes" :key="index" :value="charge_type.id">{{charge_type.name}}</option>
                </select>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>Horario en que comienza a considerarse la cantidad de citas</label>
                <date-picker
                  v-model="appointment_startdate"
                  lang="es"
                  type="datetime"
                  required
                  format="DD/MM/YYYY HH:mm"
                  :time-picker-options="{ start: '00:00', step: '01:00', end: '23:00' }"
                ></date-picker>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>Horario en que finaliza la cantidad de citas</label>
                <date-picker
                  v-model="appointment_enddate"
                  lang="es"
                  type="datetime"
                  required
                  format="DD/MM/YYYY HH:mm"
                  :time-picker-options="{ start: '00:00', step: '01:00', end: '23:00' }"
                ></date-picker>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="modal-footer">
          <button @click="saveAppointment()" type="button" class="btn btn-primary">Guardar</button>
          <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  name: "ModalAddAppointments",
  props: [
    "showModalAppointments",
    "specialChargeTypes",
    "port",
    "specialOperation",
    "addAppointments",
    "serviceSelected"
  ],
  components: {},
  data() {
    return {
      appointments: [],
      text: "",
      qty: '',
      appointment_startdate: moment().add(1, 'hours').format('YYYY-MM-DD HH:00:00'),
      appointment_enddate: moment().add(5, 'hours').format('YYYY-MM-DD HH:00:00'),
      charge_type_id: null
    };
  },
  methods: {
    saveAppointment() {
      const {
        chargeType,
        addAppointments,
        port,
        qty,
        appointment_startdate,
        appointment_enddate,
        charge_type_id
      } = this;

      let data = {
        qty,
        appointment_startdate: moment(appointment_startdate).format('YYYY-MM-DD HH:mm:00'),
        appointment_enddate: moment(appointment_enddate).format('YYYY-MM-DD HH:mm:00'),
        port_id: port.id,
        charge_type_id,
        service_type_code: this.serviceSelected
      };
      addAppointments(data);
      this.close();
    },
    close() {
      this.qty = '';
      this.charge_type_id = null;
      this.$emit("close");
    }
  }
};
</script>